import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { MsalProvider } from '@azure/msal-react';

import store from './redux/store';
import Router from './components/Router';
import { AuthProvider } from './contexts/AuthContext';
import { msalInstance } from './msalConfig';
import * as serviceWorker from './serviceWorker';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';

msalInstance.initialize()
    .then(() => msalInstance.handleRedirectPromise())
    .then(() => {
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <MsalProvider instance={msalInstance}>
                        <BrowserRouter>
                            <AuthProvider>
                                <Router />
                            </AuthProvider>
                        </BrowserRouter>
                        <ToastContainer position="bottom-center" />
                    </MsalProvider>
                </Provider>
            </React.StrictMode>,
            document.getElementById('root')
        );
    });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
